/* Velour — košík nad Shopify Ajax Cart API (/cart/add.js, /cart/change.js, /cart.js).
   Drží jediný stav košíka pre celý web: počítadlo v hlavičke, potvrdzovacie
   okno po pridaní (snippets/cart-added.liquid) a cez onCartChange aj stránku
   /cart. Položky sa upravujú len tam — okno po pridaní je iba potvrdenie. */
(function () {
  window.VELOUR = window.VELOUR || {};

  var addedPopup = document.getElementById('cartAdded');
  var cartOverlay = document.getElementById('cartOverlay');
  var addedItemEl = document.getElementById('cartAddedItem');
  var cartTotalEl = document.getElementById('cartTotal');
  var cartCountEl = document.getElementById('cartCount');
  var shippingLabel = document.getElementById('cartShippingLabel');
  var shippingFill = document.getElementById('cartShippingFill');
  var lastFocused = null;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Obrázok z Ajax Cart API príde v pôvodnej veľkosti — v okne je náhľad
     malý, tak si vypýtame šírku a nesťahujeme originál. */
  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function money(cents) {
    var v = (cents / 100);
    var s = v.toFixed(2);
    if (s.endsWith('.00')) s = s.slice(0, -3);
    return s + ' €';
  }
  window.VELOUR.money = money;

  /* Toast už hlási len chyby — úspešné pridanie potvrdzuje okno
     snippets/cart-added.liquid, dve hlásenia naraz boli zbytočné. */
  function showToast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(function () { t.classList.remove('show'); }, 2500);
  }
  window.VELOUR.showToast = showToast;

  /* Poznámka "1 ml posielame v 2 ml flakóne" patrí len k tej jednej veľkosti,
     tak sa ukazuje a skrýva podľa zvoleného tlačidla. Žije tu, lebo ju
     potrebuje katalóg (velour-cart.js je jediné JS spoločné obom stránkam)
     aj detail vône. `scope` je karta produktu alebo celá stránka detailu.
     Text vykresľuje snippets/vial-note.liquid. */
  function syncVialNote(scope) {
    var note = scope.querySelector('.vial-note');
    if (!note) return;
    var selected = scope.querySelector('.size-btn.selected');
    note.hidden = !selected || selected.dataset.size !== note.dataset.noteSize;
  }
  window.VELOUR.syncVialNote = syncVialNote;

  /* Tá istá poznámka v košíku — je to posledné miesto pred platbou, kde ešte
     "1ml" pri položke môže zákazníka prekvapiť. Košík vykresľuje JS z Ajax
     Cart API, takže sa tu skladá reťazcom, nie snippetom. */
  var VIAL_SIZE = '1ml';
  function vialNote(variantTitle) {
    if (variantTitle !== VIAL_SIZE) return '';
    return '<div class="cart-line-vial">Posielame v 2 ml flakóne</div>';
  }
  window.VELOUR.vialNote = vialNote;

  // Dodávka namiesto fajky, keď je doprava zadarmo. Inline SVG, aby to bola
  // jedna požiadavka menej a aby sa dala zafarbiť cez currentColor.
  var VAN_ICON = '<svg class="cart-van" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 2h12v9H1z"/><path d="M13 5h4l3 3v3h-7z"/><circle cx="6" cy="12.5" r="1.8"/><circle cx="16.5" cy="12.5" r="1.8"/></svg>';


  function renderShipping(totalCents) {
    if (!shippingLabel || !shippingFill) return;
    var freeFrom = window.VELOUR.freeShippingFromCents || 5000;
    var missing = freeFrom - totalCents;
    if (totalCents <= 0) {
      shippingLabel.innerHTML = 'Doprava na výdajné miesto zadarmo od ' + money(freeFrom);
      shippingFill.style.width = '0%';
      shippingFill.classList.remove('full');
      shippingLabel.classList.remove('is-free');
    } else if (missing > 0) {
      shippingLabel.innerHTML = 'Ešte <strong>' + money(missing) + '</strong> a doprava na výdajné miesto je zadarmo';
      shippingFill.style.width = Math.min(100, (totalCents / freeFrom) * 100) + '%';
      shippingFill.classList.remove('full');
      shippingLabel.classList.remove('is-free');
    } else {
      shippingLabel.innerHTML = VAN_ICON + 'Doprava na výdajné miesto zadarmo';
      shippingLabel.classList.add('is-free');
      shippingFill.style.width = '100%';
      shippingFill.classList.add('full');
    }
  }

  function calculateCartDiscount(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return { discountCents: 0, effectiveTotal: 0, qualifyingCount: 0, isDiscounted: false };
    }

    if (cart.total_discount > 0) {
      return {
        discountCents: cart.total_discount,
        effectiveTotal: cart.total_price,
        qualifyingCount: cart.items.length,
        isDiscounted: true
      };
    }

    var qualifyingItems = cart.items.filter(function (item) {
      var vt = (item.variant_title || '').trim().toLowerCase();
      var is1ml = vt === '1ml' || vt === '1 ml';
      var isSet = item.product_type === 'Set';
      return !is1ml && !isSet;
    });

    var qualifyingCount = qualifyingItems.reduce(function (sum, it) { return sum + it.quantity; }, 0);

    if (qualifyingCount >= 5) {
      var qualifyingTotal = qualifyingItems.reduce(function (sum, it) { return sum + it.final_line_price; }, 0);
      var discountCents = Math.round(qualifyingTotal * 0.10);
      return {
        discountCents: discountCents,
        effectiveTotal: Math.max(0, cart.total_price - discountCents),
        qualifyingCount: qualifyingCount,
        isDiscounted: true
      };
    }

    return {
      discountCents: 0,
      effectiveTotal: cart.total_price,
      qualifyingCount: qualifyingCount,
      isDiscounted: false
    };
  }
  window.VELOUR.calculateCartDiscount = calculateCartDiscount;

  function renderCart(cart) {
    var count = cart.item_count || 0;
    if (cartCountEl) {
      cartCountEl.textContent = count;
      cartCountEl.classList.toggle('visible', count > 0);
      cartCountEl.classList.add('pop');
      setTimeout(function () { cartCountEl.classList.remove('pop'); }, 200);
    }
    var discountInfo = calculateCartDiscount(cart);
    var effectiveTotal = discountInfo.effectiveTotal;
    if (cartTotalEl) cartTotalEl.textContent = money(effectiveTotal);
    renderShipping(effectiveTotal);
  }

  /* Položka v okne potvrdenia po pridaní. */
  function itemRowHtml(item) {
    var img = item.image
      ? '<img src="' + esc(sized(item.image, 200)) + '" alt="" width="48" height="60">'
      : '';
    /* Cena je za celý riadok, nie za kus — pri druhom pridaní tej istej
       veľkosti by inak číslo nesedelo s tým, čo zákazník práve klikol. */
    var size = item.variant_title && item.variant_title !== 'Default Title'
      ? esc(item.variant_title) : '';
    if (item.quantity > 1) size += (size ? ' × ' : '× ') + item.quantity;
    var variant = size ? '<div class="cart-added-size">' + size + '</div>' : '';
    return '' +
      '<div class="cart-added-row">' +
        '<div class="cart-added-visual">' + img + '</div>' +
        '<div class="cart-added-info">' +
          '<div class="cart-added-brand">' + esc(item.vendor) + '</div>' +
          '<div class="cart-added-name">' + esc(item.product_title) + '</div>' +
          variant +
          vialNote(item.variant_title) +
        '</div>' +
        '<div class="cart-added-price">' + money(item.final_line_price) + '</div>' +
      '</div>';
  }

  /* Zoznam položiek v košíku v okne potvrdenia. Ak je v košíku viac vecí,
     ukážu sa všetky — nielen tá práve pridaná. */
  function renderAddedItem(cartOrItem) {
    if (!addedItemEl || !cartOrItem) return;
    var items = cartOrItem.items ? cartOrItem.items : (Array.isArray(cartOrItem) ? cartOrItem : [cartOrItem]);
    addedItemEl.innerHTML = items.map(itemRowHtml).join('');
  }

  /* Košík vykresľuje drawer aj stránka /cart. Aby nemuseli o sebe vedieť,
     každá zmena prejde cez applyCart a odberatelia sa dozvedia sami. */
  var listeners = [];
  window.VELOUR.onCartChange = function (cb) {
    listeners.push(cb);
    if (window.VELOUR._lastCart) cb(window.VELOUR._lastCart);
  };

  function applyCart(cart) {
    window.VELOUR._lastCart = cart;
    renderCart(cart);
    listeners.forEach(function (cb) { cb(cart); });
    return cart;
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(applyCart);
  }
  window.VELOUR.refreshCart = refreshCart;

  /* properties = vlastnosti položky (Shopify line item properties). Nesú sa
     s položkou do košíka, do pokladne aj do objednávky — takto zákazník pri
     sete vidí, ktoré tri vône v ňom sú, aj keď tam nie je obrázok. Názov
     vlastnosti nesmie začínať podčiarkovníkom, inak ju Shopify skryje. */
  function addToCart(variantId, quantity, properties) {
    var payload = { id: variantId, quantity: quantity || 1 };
    if (properties && Object.keys(properties).length) payload.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Chyba pri pridávaní do košíka'); });
      return r.json();
    }).then(function (addedItem) {
      return refreshCart().then(function (cart) {
        return { cart: cart, addedItem: addedItem };
      });
    }).then(function (res) {
      /* Okno je potvrdenie pridania. Na samotnej stránke košíka by prekrylo
         to, čo už zákazník vidí, tak ho tam neotvárame. */
      if (!document.body.classList.contains('template-cart')) {
        openAdded(res.cart, res.addedItem);
      }
      return res.cart;
    });
  }
  window.VELOUR.cartAdd = addToCart;

  /* Zloženie setu príde z metafieldu ako viacriadkový text. Spojíme ho na
     jeden riadok, lebo vlastnosť položky sa v pokladni zobrazuje ako jeden
     reťazec a zalomenia by v nej ostali ako medzery navyše.
     Vráti null, keď zloženie nie je — vtedy sa žiadna vlastnosť neposiela. */
  window.VELOUR.setContents = function (raw) {
    if (!raw) return null;
    var text = raw.split('\n').map(function (r) { return r.trim(); })
                  .filter(Boolean).join(' · ');
    return text ? { 'Obsahuje': text } : null;
  };

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(applyCart);
  }
  window.VELOUR.changeLine = changeLine;

  /* Aktualizácia bloku "Vytvor si set 5 odstrekov (-10 %)" v okne potvrdenia. */
  function updateBundlePromo(cart, addedItem) {
    var promoEl = document.getElementById('cartAddedBundle');
    if (!promoEl) return;
    if (!cart || !cart.items) {
      promoEl.hidden = true;
      return;
    }

    var addedSize = '';
    var isAddedSet = false;
    if (addedItem) {
      if (addedItem.product_type === 'Set') isAddedSet = true;
      var vTitle = (addedItem.variant_title || '').trim().toLowerCase();
      if (vTitle.indexOf('10ml') !== -1) addedSize = '10ml';
      else if (vTitle.indexOf('5ml') !== -1) addedSize = '5ml';
      else if (vTitle.indexOf('2ml') !== -1) addedSize = '2ml';
      else if (vTitle.indexOf('1ml') !== -1) addedSize = '1ml';
    }

    // Kvalifikujúce odstreky (2ml, 5ml, 10ml) v košíku
    var qualifyingItems = cart.items.filter(function (it) {
      if (it.product_type === 'Set') return false;
      var s = (it.variant_title || '').trim().toLowerCase();
      return s.indexOf('2ml') !== -1 || s.indexOf('5ml') !== -1 || s.indexOf('10ml') !== -1;
    });

    var qualifyingCount = qualifyingItems.reduce(function (sum, it) { return sum + it.quantity; }, 0);

    // Ak zákazník pridal hotový kurátorský set a v košíku nemá žiadne samostatné odstreky, skryjeme
    if (isAddedSet && qualifyingCount === 0) {
      promoEl.hidden = true;
      return;
    }

    // Cieľová veľkosť pre konfigurátor
    var targetSize = (addedSize && addedSize !== '1ml') ? addedSize : '2ml';
    if (!targetSize) {
      var lastQual = qualifyingItems[qualifyingItems.length - 1];
      var lastTitle = (lastQual && lastQual.variant_title ? lastQual.variant_title : '').toLowerCase();
      if (lastTitle.indexOf('10ml') !== -1) targetSize = '10ml';
      else if (lastTitle.indexOf('5ml') !== -1) targetSize = '5ml';
      else targetSize = '2ml';
    }

    var bundleUrl = '/collections/odstreky-parfumov?view=bundle' + (targetSize ? '&size=' + encodeURIComponent(targetSize) : '');

    var counterEl = document.getElementById('cabCounter');
    var titleEl = document.getElementById('cabTitle');
    var descEl = document.getElementById('cabDesc');
    var ctaEl = document.getElementById('cabCta');
    var ctaTextEl = document.getElementById('cabCtaText');
    var dots = promoEl.querySelectorAll('.cab-dot');

    var displayCount = Math.min(5, qualifyingCount);
    dots.forEach(function (dot, i) {
      dot.classList.toggle('active', i < displayCount);
    });

    if (qualifyingCount >= 5) {
      promoEl.classList.add('is-completed');
      if (counterEl) counterEl.textContent = 'Zľava 10 % uplatnená ✓';
      if (titleEl) titleEl.textContent = 'Máš poskladaný set so zľavou 10 %!';
      if (descEl) descEl.textContent = 'Zľava 10 % na tvoje odstreky je automaticky odpočítaná v košíku.';
      if (ctaTextEl) ctaTextEl.textContent = 'Upraviť set v konfigurátore';
    } else {
      promoEl.classList.remove('is-completed');
      var rem = 5 - qualifyingCount;

      if (qualifyingCount === 0) {
        // Zákazník pridal napr. 1ml vzorku — ponúkneme mu výhodnejší set
        if (counterEl) counterEl.textContent = '10 % zľava pri 5 vôňach';
        if (titleEl) titleEl.textContent = 'Vytvor si set 5 odstrekov a ušetri 10 %';
        if (descEl) descEl.textContent = 'Poskladaj si set 5 odstrekov (2, 5 alebo 10 ml) a získaj 10 % zľavu na celý set.';
        if (ctaTextEl) ctaTextEl.textContent = 'Vytvoriť set so zľavou 10 %';
      } else if (qualifyingCount === 1) {
        if (counterEl) counterEl.textContent = '1 z 5 vôní v sete';
        if (titleEl) titleEl.textContent = 'Vytvor si set 5 odstrekov a ušetri 10 %';
        if (descEl) descEl.textContent = 'Pridaj ešte 4 odstreky (2, 5 alebo 10 ml) a zľava 10 % sa uplatní automaticky.';
        if (ctaTextEl) ctaTextEl.textContent = 'Vytvoriť set so zľavou 10 %';
      } else {
        if (counterEl) counterEl.textContent = qualifyingCount + ' z 5 vôní v sete';
        var remText = rem === 1 ? 'posledný 1 odstrek' : (rem >= 2 && rem <= 4 ? 'ešte ' + rem + ' odstreky' : 'ešte ' + rem + ' odstrekov');
        if (titleEl) titleEl.textContent = 'Už len ' + (rem === 1 ? '1 odstrek' : rem + ' odstreky') + ' do setu so zľavou 10 %';
        if (descEl) descEl.textContent = 'Pridaj ' + remText + ' (2, 5 alebo 10 ml) a získaj 10 % zľavu na celý set.';
        if (ctaTextEl) ctaTextEl.textContent = 'Doplniť set o ďalšie vône';
      }
    }

    if (ctaEl) ctaEl.href = bundleUrl;
    promoEl.hidden = false;
  }

  function openAdded(cartOrItem, addedItem) {
    if (!addedPopup) return;
    var cart = cartOrItem && cartOrItem.items ? cartOrItem : window.VELOUR._lastCart;
    renderAddedItem(cartOrItem || window.VELOUR._lastCart);
    updateBundlePromo(cart, addedItem);
    lastFocused = document.activeElement;
    addedPopup.hidden = false;
    // Trieda až v ďalšom rámci, inak prehliadač preskočí prechod z hidden.
    requestAnimationFrame(function () { addedPopup.classList.add('open'); });
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    var go = document.getElementById('cartAddedGo');
    if (go) go.focus();
  }
  function closeAdded() {
    if (!addedPopup || addedPopup.hidden) return;
    addedPopup.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
    // Skryť až po dobehnutí prechodu, nech okno nezmizne skokom.
    setTimeout(function () { if (!addedPopup.classList.contains('open')) addedPopup.hidden = true; }, 260);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
  }
  window.VELOUR.openAdded = openAdded;
  window.VELOUR.closeAdded = closeAdded;

  document.addEventListener('DOMContentLoaded', function () {
    /* Ikonka košíka je odkaz na /cart, nie spúšťač okna — okno sa otvára
       samo po pridaní položky ako potvrdenie (viď addToCart). */
    var back = document.getElementById('cartAddedBack');
    if (back) back.addEventListener('click', closeAdded);
    if (cartOverlay) cartOverlay.addEventListener('click', closeAdded);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAdded();
    });
    refreshCart();
  });
})();
